import script from "./ViberBlocked.vue?vue&type=script&setup=true&lang=js"
export * from "./ViberBlocked.vue?vue&type=script&setup=true&lang=js"

import "./ViberBlocked.vue?vue&type=style&index=0&id=6ca4f2d3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ca4f2d3"]])

export default __exports__